"use client";

import { c as _c } from "react-compiler-runtime";
import type { Phase } from "@/hooks/useProcessingProgress/useProcessingProgress";
import FaceScanOverlay from "./FaceScanOverlay";
import GlowOverlay from "./GlowOverlay";
import GoldenRatioOverlay from "./GoldenRatioOverlay";
import ScanLineOverlay from "./ScanLineOverlay";
import type { ProcessingImageOverlay } from "./types";
type ProcessingOverlayLayerProps = {
  overlay: ProcessingImageOverlay;
  phase: Phase;
  activeStepIndex: number;
};
export default function ProcessingOverlayLayer(t0) {
  const $ = _c(9);
  const {
    overlay,
    phase,
    activeStepIndex
  } = t0;
  if (overlay.type === "glow") {
    let t1;
    if ($[0] !== overlay.color || $[1] !== phase) {
      t1 = phase === "completing" ? <GlowOverlay color={overlay.color} /> : null;
      $[0] = overlay.color;
      $[1] = phase;
      $[2] = t1;
    } else {
      t1 = $[2];
    }
    return t1;
  }
  if (overlay.type === "goldenRatio") {
    const t1 = phase === "running" || phase === "completing";
    let t2;
    if ($[3] !== t1) {
      t2 = <GoldenRatioOverlay isActive={t1} />;
      $[3] = t1;
      $[4] = t2;
    } else {
      t2 = $[4];
    }
    return t2;
  }
  if (phase !== "running") {
    return null;
  }
  if (overlay.type === "faceScan") {
    let t1;
    if ($[5] !== activeStepIndex || $[6] !== overlay.landmarks) {
      t1 = <FaceScanOverlay isActive={true} currentStep={activeStepIndex} landmarks={overlay.landmarks} />;
      $[5] = activeStepIndex;
      $[6] = overlay.landmarks;
      $[7] = t1;
    } else {
      t1 = $[7];
    }
    return t1;
  }
  let t1;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <ScanLineOverlay />;
    $[8] = t1;
  } else {
    t1 = $[8];
  }
  return t1;
}